export default __webpack_public_path__ + "static/media/modal_banner.a217191e.png";